import React, { useCallback } from 'react';
import moment from 'moment';
import severityValues from './SeverityValues';

const AdjusterEmailDetails = ({ policy, data }) => {
	const { policyNumber } = policy;

    const severity = severityValues.find((x) => x.value === data.severity);
	let severityText = severity ? severity.text : '';

    if ((data.medicalAttention || 0) > 0) {
		severityText = severityText.replace('Loss', 'Injury');
	}

	const conditionalRender = useCallback((label, value) => {
		if (!value || value === '') return null;

		return (
			<tr>
				<td>{label}</td>
				<td>{value}</td>
			</tr>
		);
	}, []);

	return (
		<div>
		    <table border='1'>
			    <tr>
				    <td colSpan='2' align='center'>
					    <b>Basic Information</b>
				    </td>
			    </tr>
			    <tr>
				    <td colSpan='2' align='center'>
					    <b>CLAIM WAS AUTOMATICALLY ASSIGNED BY DIAMOND</b>
				    </td>
			    </tr>
			    <tr>
				    <td>Diamond Claim Number</td>
				    <td>{'{ClaimNumber}'}</td>
			    </tr>
			    <tr>
				    <td>Date</td>
				    <td>{moment().format('MM/DD/YYYY')}</td>
			    </tr>
			    <tr>
				    <td>Policy Number</td>
				    <td>{policyNumber}</td>
			    </tr>
			    <tr>
				    <td>Loss Date</td>
				    <td>{moment(data.lossDate).format('MM/DD/YYYY')}</td>
			    </tr>
			    <tr>
				    <td>Agency Name</td>
				    <td>{data.agency.displayName}</td>
			    </tr>
			    <tr>
				    <td>Agency Phone</td>
				    <td>{data.agency.phones[0]}</td>
			    </tr>
			    <tr>
				    <td>Agency FAX</td>
				    <td>{data.agency.faxes[0]}</td>
			    </tr>

			    <tr>
				    <td colSpan='2' align='center'>
					    <b>Insured Information</b>
				    </td>
			    </tr>
			    <tr>
				    <td>Primary Contact</td>
				    <td>
					    {data.otherContactFirstName} {data.otherContactLastName}
				    </td>
			    </tr>
			    {conditionalRender('Primary Contact Cell Phone', data.otherContactCellPhone)}
			    {conditionalRender('Primary Contact Home Phone', data.otherContactHomePhone)}
			    {conditionalRender('Primary Contact Work Phone', data.otherContactWorkPhone)}
			    {conditionalRender('Insured First Name', data.policyHolder.firstName)}
			    {conditionalRender('Insured Last Name', data.policyHolder.lastName)}
			    {conditionalRender('Insured Cell Phone', data.insuredCellPhone)}
			    {conditionalRender('Insured Home Phone', data.insuredHomePhone)}
			    {conditionalRender('Insured Work Phone', data.insuredWorkPhone)}
			    {conditionalRender('Insured Preferred Email', data.preferredEmailAddress)}
			    {conditionalRender('Insured Address', data.policyHolder.address1)}
			    {conditionalRender('Insured City', data.policyHolder.city)}
			    {conditionalRender('Insured State', data.policyHolder.state)}
			    {conditionalRender('Insured Zip', data.policyHolder.postalCode)}

			    {(data.involvedDriverFirstName || data.involvedDriverLastName) && (
				    <>
					    <tr>
						    <td colSpan='2' align='center'>
							    <b>Insured Vehicle Driver</b>
						    </td>
					    </tr>
					    <tr>
						    <td>Driver First</td>
						    <td>{data.involvedDriverFirstName}</td>
					    </tr>
					    <tr>
						    <td>Driver Last</td>
						    <td>{data.involvedDriverLastName}</td>
					    </tr>
				    </>
			    )}

			    <tr>
				    <td colSpan='2' align='center'>
					    <b>Loss Information</b>
				    </td>
			    </tr>
                
			    {conditionalRender('Loss Location', data.lossLocation)}
			    {conditionalRender('Loss City', data.lossCity)}
			    {conditionalRender('Loss State', data.lossStateName)}
			    {conditionalRender('Loss Description', data.whatHappened)}
			    {conditionalRender('Loss Severity', severityText)}

			    {(data.involvedVehicleMake ||
				    data.involvedVehicleModel ||
				    data.involvedVehicleYear ||
				    data.involvedVehicleVin) && (
					    <>
						    <tr>
							    <td colSpan='2' align='center'>
								    <b>Vehicle Information</b>
							    </td>
						    </tr>
						    {conditionalRender('Vehicle Make', data.involvedVehicleMake)}
						    {conditionalRender('Vehicle Model', data.involvedVehicleModel)}
						    {conditionalRender('Vehicle Year', data.involvedVehicleYear)}
						    {conditionalRender('VIN', data.involvedVehicleVin)}
					    </>
				    )}

			    {data.thirdParties.map((thirdParty) => (
				    <React.Fragment>
					    <tr>
						    <td colSpan='2' align='center'>
							    <b>Other Vehicle Driver</b>
						    </td>
					    </tr>
					    {conditionalRender('Driver First', thirdParty.firstName)}
					    {conditionalRender('Driver Middle', thirdParty.middleName)}
					    {conditionalRender('Driver Last', thirdParty.lastName)}
					    {conditionalRender('Driver Address', thirdParty.address)}
					    {conditionalRender('Driver City', thirdParty.city)}
					    {conditionalRender('Driver State', thirdParty.state)}
					    {conditionalRender('Driver Zip', thirdParty.zip)}
					    {conditionalRender('Driver Cell Phone', thirdParty.cellPhone)}
					    {conditionalRender('Driver Home Phone', thirdParty.homePhone)}
					    {conditionalRender('Driver Work Phone', thirdParty.businessPhone)}
				    </React.Fragment>
			    ))}
		    </table>
	        <p>
                Note: If this loss was incurred on a previous policy image, you may need to obtain an older version of the Declaration for the policy image that was in force when the loss incurred.
			</p>
		</div>

	);
};

export default AdjusterEmailDetails;
